var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"referrer-catcher"},[_c('v-container',[_vm._v(" Espere por favor... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }